/* eslint-disable @typescript-eslint/restrict-template-expressions */
import useDispensary from 'src/dispensary/hooks/use-dispensary';

export const useGetReferralUrl = (code: string | null): string | null => {
  const dispensary = useDispensary();
  const { customDomainSettings, cName } = dispensary.dispensary ?? {};

  const hostUrl = window.location.host;

  if (!code || !cName) {
    return null;
  }

  const customDomain = customDomainSettings?.domain;
  const path = `${cName}/referral/${code}`;

  if (customDomain) {
    return `https://${customDomain}/stores/${path}`;
  }

  return `https://${hostUrl}/stores/${path}`;
};
